import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { SelectionGroup, SelectionGroupItem, Typography, Adaptive } from 'fronton-react';
import { DoorGlazed, DoorBlank, DoorGlass, DoorGlazedSmall, DoorBlankSmall, DoorGlassSmall } from 'assets';
import { doorTypeLabels } from '../../const';
import { HeaderContainer, SelectionGroupContent, SelectionGroupClassname, IconContainer } from './styles';
import { DoorType, ParametersEnum, TGetIcon } from '../../types';
import { getNextValueMultiChoice } from '../../helpers/get-selection-group-next-value';

const doorTypes = [
  {
    name: DoorType.GLASS,
    label: doorTypeLabels.GLASS,
    getIcon: ({ isSmall }: TGetIcon) => (isSmall ? <DoorGlassSmall /> : <DoorGlass />),
  },
  {
    name: DoorType.BLANK,
    label: doorTypeLabels.BLANK,
    getIcon: ({ isSmall }: TGetIcon) => (isSmall ? <DoorBlankSmall /> : <DoorBlank />),
  },
  {
    name: DoorType.GLAZED,
    label: doorTypeLabels.GLAZED,
    getIcon: ({ isSmall }: TGetIcon) => (isSmall ? <DoorGlazedSmall /> : <DoorGlazed />),
  },
];

export const DoorModelParams = () => {
  const { control, setValue } = useFormContext();

  return (
    <div>
      <HeaderContainer>
        <Adaptive to="tablet">
          <Typography variant="m" color="text-primary" size="subtitle">
            Модель двери
          </Typography>
        </Adaptive>
        <Adaptive from="tablet">
          <Typography variant="l" color="text-primary" size="body_accent">
            Модель двери
          </Typography>
        </Adaptive>
      </HeaderContainer>
      <Controller
        name={ParametersEnum.doorType}
        control={control}
        render={({ field: { onChange, value } }) => (
          <SelectionGroup
            active={value}
            onChange={(_, doorTypeValue) => {
              onChange();
              setValue(
                ParametersEnum.doorType,
                getNextValueMultiChoice({
                  clickedValue: doorTypeValue,
                  currentValue: value,
                })
              );
            }}
            variant="composite"
            size="l"
            className={SelectionGroupClassname}>
            {doorTypes.map(doorTypeItem => (
              <SelectionGroupItem
                key={doorTypeItem.name}
                value={doorTypeItem.name}
                data-testid={`${doorTypeItem.name}-door-type-select`}>
                <SelectionGroupContent>
                  <IconContainer>
                    <Adaptive to="tablet">{doorTypeItem.getIcon({ isSmall: true })}</Adaptive>
                    <Adaptive from="tablet">{doorTypeItem.getIcon({ isSmall: false })}</Adaptive>
                  </IconContainer>
                  <Typography variant="m" size="body_accent" color="text-primary">
                    {doorTypeItem.label}
                  </Typography>
                </SelectionGroupContent>
              </SelectionGroupItem>
            ))}
          </SelectionGroup>
        )}
      />
    </div>
  );
};
